export const environment_us_prod = {
  PRODUCTION: true,
  APP_ENDPOINT: 'https://app.us.printix.net',
  CHECK_SERVER_HEALTH: 'https://api.us.printix.net/manage/health',
  INTERNAL_TEST_WAIT_TIME: 'https://api.us.printix.net/internal/testing/wait/',
  INTERNAL_TEST_RETURN_SET_STATUS_CODE: 'https://api.us.printix.net/internal/testing/status/',
  ENDPOINT_API: 'https://api.us.printix.net',
  ENDPOINT_TENANT_DOMAIN: 'https://auth.us.printix.net/oauth/authorize/tenant/',
  ENDPOINT_TENANT_LESS: 'https://auth.us.printix.net/oauth/authorize',
  ENDPOINT_SIGN_IN_MS: 'https://auth.us.printix.net/identity-providers/azure/signin?redirect_uri=',
  ENDPOINT_SIGN_IN_GOOGLE: 'https://auth.us.printix.net/identity-providers/google/signin?redirect_uri=',
  ENDPOINT_AUTH_TOKENS: 'https://auth.us.printix.net/oauth/token',
  ENDPOINT_GET_TENANT_USER: 'https://api.us.printix.net/v1/users/me',
  ENDPOINT_FIND_TENANT: 'https://api.us.printix.net/v1.2/find/',
  ENDPOINT_SIGN_OUT_BROWSER: 'https://auth.us.printix.net/logout',
  ENDPOINT_SIGN_OUT_NATIVE: 'https://auth.us.printix.net/oauth/logout',
  ENDPOINT_REVOKE_TOKEN: 'https://auth.us.printix.net/oauth2/revoke',
  ENVIRONMENT_STATE: 'production'
};